import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { get } from "lodash";
import MOMDesc from "./MOMDesc";
import { dateFormat, isValidArray } from "../../helper";
import { Link } from "react-router-dom";
import { PATHS } from "../../constant";
import PermissionHOC from "../PermissionHOC";
import { DisplayAttachments } from "../reusableComponent";
import { isValid } from "date-fns";

class MOM extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { momDesc, meetingDecisionDTOS, permission } = this.props;
    return (
      <React.Fragment>
        <Container fluid className="mom">
          <Row>
            {(get(meetingDecisionDTOS, "meetingId") && (
              <Col lg={momDesc ? 4 : 12}>
                <div className="agenda-number">
                  Agenda{" "}
                  {get(permission, "readAgenda") &&
                  get(meetingDecisionDTOS, "meetingDTO.clickable") ? (
                    <Link
                      to={{
                        pathname: PATHS.AGENDA_DETAILS,
                        search: `?agendaId=${get(
                          meetingDecisionDTOS,
                          "meetingId",
                          "NA"
                        )}`,
                        state: {
                          agendaId: get(meetingDecisionDTOS, "meetingId")
                        }
                      }}
                    >
                      #{get(meetingDecisionDTOS, "meetingId", null)}
                    </Link>
                  ) : (
                    <span>#{get(meetingDecisionDTOS, "meetingId")}</span>
                  )}
                </div>
                <h3>
                  {get(meetingDecisionDTOS, "meetingDTO.meetingName", null)}
                </h3>
                <div className="meeting-info meeting-when">
                  <span>
                    <b>When</b>
                    {dateFormat(
                      get(meetingDecisionDTOS, "meetingDTO.meetingDate", null)
                    )}
                  </span>
                </div>
                <div className="meeting-info meeting-venue">
                  <span>
                    <b>Venue</b>
                    {get(meetingDecisionDTOS, "meetingDTO.venue", null)}
                  </span>
                </div>

                {/* <div className="meeting-info meeting-attended">
                  <span>
                    <b>Attended</b>
                    {get(meetingDecisionDTOS, "meetingDTO.attended", null)}
                  </span>
                </div> */}
              </Col>
            )) ||
              null}

            {momDesc ? (
              <Col lg={!get(meetingDecisionDTOS, "meetingId") ? 12 : 8}>
                <MOMDesc
                  readMore="true"
                  meeting={meetingDecisionDTOS}
                  count={meetingDecisionDTOS ? meetingDecisionDTOS.length : 0}
                />
              </Col>
            ) : (
              ""
            )}

            {/* {isValidArray(get(meetingDecisionDTOS, "fileDTOList")) &&
            get(meetingDecisionDTOS, "meetingDTO") ? (
              <Col lg={12} className="meeting-attachments">
                <span className="title">Attachment(s) - </span>
                {get(meetingDecisionDTOS, "fileDTOList", []).map(
                  (val, index) => {
                    return (
                      <a
                        href={val.s3Url}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {val.title}
                        {index <
                        get(meetingDecisionDTOS, "fileDTOList", []).length - 1
                          ? ", "
                          : ""}{" "}
                      </a>
                    );
                  }
                )}
              </Col>
            ) : null
            } */}
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default PermissionHOC(MOM);
